import DownloadStorageManage from './download-storage-manage';
import { constants as config } from '@config';

const videoSizeToResolution = {
  '2k': 2560,
  '1080p': 1080,
  '720p': 720,
  '480p': 480,
  '360p': 360
};

const bleed = require('./download-bleeds-settings');
const msgNoPagesSelected = INKIVE.TranslateHelper.translate('top_submenu.download_modal.select_pages_error');
const msgPagesSelected = INKIVE.TranslateHelper.translate('top_submenu.download_modal.download_pages');
const msgPageSelected = INKIVE.TranslateHelper.translate('top_submenu.download_modal.download_page');

export let quality = 'print';
export let selectedPages = [];
export let downloadRangeChangedByUser;
let currentePageOnly = false;

export const downloadDefaultRange = () => {
  const selectedCheckBoxesMenu = document.querySelector('div.select-range-type');

  if (selectedCheckBoxesMenu) {
    selectedCheckBoxesMenu.classList.remove('flash-warning');
    rangeInitialValue();
  }

  selectDefaultPages();
  disableDownloadIfNoPagesSelected(selectedPages);
  checkPagesTotal();

  selectedPages.sort((a, b) => a - b);
};

const selectDefaultPages = () => {
  const wrapper = document.querySelector('.content-item-wrapper[data-active="true"]');
  let defaultPrintPage = 1;
  if (wrapper) defaultPrintPage = parseInt(wrapper.getAttribute('data-currpage')) + 1;

  currentePageOnly = false;
  document.querySelector('div.desygner-dropdown-selected.select-range-type').classList.remove('disable');

  DownloadStorageManage.setUrlValue();
  const pagesRegaHistorage = DownloadStorageManage.currentStorage('pages-to-dowload');
  const pageInex = DownloadStorageManage.findIndexOfStorageByKey('pages-to-dowload');
  const pagesSessionStorage = pageInex !== -1 && pagesRegaHistorage ? pagesRegaHistorage[pageInex] : null;
  const fileType = DownloadStorageManage.getDownloadFormat();

  if (pagesSessionStorage) {
    selectedPages = pagesSessionStorage.pages;
  } else {
    if (fileType === 'pdf-print' || fileType === 'pdf-stand') {
      const allPages = [];
      for (let index = 0; index < INKIVE.C.BOOK.num_pages; index++) {
        allPages.push(index + 1);
      }
      selectedPages = INKIVE.C.BOOK.num_pages > 10 ? [] : allPages;
    } else {
      selectedPages = [];
      selectedPages.push(defaultPrintPage);
    }
  }
  if (fileType === 'png' || fileType === 'jpg') {
    currentePageOnly = true;
    selectedPages = [defaultPrintPage];
  }
};

const checkPagesTotal = () => {
  const numOfPages = INKIVE.C.BOOK.num_pages;
  const pagesRangeTitle = document.querySelector('div.dropdown-container.dropdown-range-container h3.download-range-title');
  const pagesRangeContent = document.querySelector('div[data-id="download"] div.select-range-type');
  if (pagesRangeTitle && pagesRangeContent) {
    if (numOfPages === 1) {
      pagesRangeTitle.classList.add('hidden');
      pagesRangeContent.classList.add('hidden');
    } else {
      pagesRangeTitle.classList.remove('hidden');
      pagesRangeContent.classList.remove('hidden');
    }
  }
};

export const warningNoPages = () => {
  const selectedCheckBoxesMenu = document.querySelector('div.select-range-type');
  selectedCheckBoxesMenu.classList.remove('flash-warning');
  window.requestAnimationFrame(() => {
    selectedCheckBoxesMenu.classList.add('flash-warning');
  });
};

export const downloadDropDownList = (event) => {
  const dropDownMenu = event.currentTarget;
  const subMenu = dropDownMenu.closest('.dropdown-container').querySelector('.desygner-dropdown-select');
  const subMenus = dropDownMenu.closest('div[data-id="download"]').querySelectorAll('.desygner-dropdown-select.visible');

  if (subMenu.classList.contains('visible')) {
    subMenu.classList.remove('visible');
  } else {
    [...subMenus].forEach(element => {
      element.classList.remove('visible');
    });
    subMenu.classList.toggle('visible');
  }
  if (subMenu.classList.contains('select-range-dropdownlist')) {
    generatePrintList(subMenu);
    $('.select-range-dropdownlist').antiscroll();
  }
};

export const generatePrintList = (target) => {
  const pagesTotal = INKIVE.C.BOOK.num_pages;
  const dropDownList = target.querySelector('.checkbox-container ul');
  const thumbs = document.querySelectorAll('.preview');

  target.querySelectorAll('.checkbox-container ul li.pages-list-item').forEach(element => {
    element.remove();
  });

  for (let checkboxes = 1; checkboxes <= pagesTotal; checkboxes++) {
    const isChecked = selectedPages.includes(checkboxes) ? 'checked' : '';
    dropDownList.innerHTML += `<li class="filter-line desygner-dropdown-select-item-range pages-list-item">
    <p class="desygner-custom-check">
      <label>
      <span style="background-image: ${thumbs[checkboxes - 1].dataset.backgroundImage}" class="page-thumbnail"></span>
        <span class="checkbox-text">${INKIVE.TranslateHelper.translate('top_submenu.download_modal.download_page')} ${checkboxes}</span>
        <input type="checkbox" id="page_${checkboxes}" value="${checkboxes}" class="export-range-page-checkbox" data-id="${checkboxes}" ${isChecked}>
        <span class="checkmark"></span>
      </label>
    </p>
  </li>`;
  }

  dropDownList.querySelector('#isRangeAll').checked = (selectedPages.length === pagesTotal);
};

const definePageCheck = (checkBox) => {
  const selectAllCheckBoxes = checkBox.closest('.dropdown-container').querySelector('[data-id=isRangeAll]');
  const totalPagesCheckBox = checkBox.closest('.dropdown-container').querySelectorAll('input[type=checkbox]');
  const allCheckBoxes = checkBox.closest('.dropdown-container').querySelectorAll('input[type=checkbox].export-range-page-checkbox');
  const totalPagesSelected = checkBox.closest('.dropdown-container').querySelectorAll('input[type=checkbox].export-range-page-checkbox:checked');

  if (checkBox.dataset.id === 'isRangeAll') {
    selectedPages.length = 0;
    [...allCheckBoxes].forEach(element => {
      element.checked = checkBox.checked;
      checkBox.checked ? selectedPages.push(parseInt(element.dataset.id)) : selectedPages.length = 0;
    });
  } else {
    selectAllCheckBoxes.checked = (totalPagesSelected.length === totalPagesCheckBox.length - 1);
    checkBox.checked
      ? selectedPages.push(parseInt(checkBox.dataset.id))
      : selectedPages.splice(selectedPages.indexOf(parseInt(checkBox.dataset.id)), 1);
  }
};

export const shortPageRange = () => {
  const selectedCheckBoxesMenu = document.querySelector('div[data-id="download"] div.select-range-type');
  let downloadRangeMessage;

  selectedPages.sort((a, b) => { return a - b; }).join(',');

  selectedPages.sort((a, b) => a - b);

  if (selectedPages.length < 1) {
    downloadRangeMessage = msgNoPagesSelected;
  } else if (selectedPages.length === 1) {
    downloadRangeMessage = `${msgPageSelected} : (${checkPagesInterval(selectedPages)})`;
  } else if (selectedPages.length >= 2) {
    downloadRangeMessage = `${msgPagesSelected} : (${checkPagesInterval(selectedPages)})`;
  }

  rangeInitialValue();
};

export const selectPagesRange = (event) => {
  const checkBox = event.currentTarget;
  const selectedCheckBoxesMenu = checkBox.closest('.ui-widget-content').querySelector('div.select-range-type');
  const downloadButton = checkBox.closest('.ui-widget-content').querySelectorAll('.download-btn-container .buttons .btn');

  definePageCheck(checkBox);
  shortPageRange();

  selectedCheckBoxesMenu.classList.toggle('error', selectedPages.length < 1);

  if (!INKIVE.EditorFacade.isLoading) {
    [...downloadButton].forEach(element => {
      element.classList.toggle('disabled', selectedPages.length < 1);
    });
  }

  const pagesSessionStorage = JSON.parse(sessionStorage.getItem('pages-to-dowload'));
  const urlParams = new URLSearchParams(window.location.search);

  DownloadStorageManage.setUrlValue();
  DownloadStorageManage.saveFieldOnStore(selectedPages, 'pages-to-dowload');

  disableDownloadIfNoPagesSelected(selectedPages);
};

const disableDownloadIfNoPagesSelected = (selectedPages) => {
  const selectedCheckBoxesMenu = document.querySelector('div.select-range-type');
  const downloadButton = document.querySelector('a.btn.btn-yellow.action[data-action]');
  if (selectedPages.length === 0) {
    selectedCheckBoxesMenu.classList.add('warning');
    !INKIVE.EditorFacade.isLoading && downloadButton.classList.remove('disabled');
  } else {
    selectedCheckBoxesMenu.classList.remove('warning');
  }
};

export const rangeInitialValue = () => {
  const submenuItem = document.querySelector('.ui-dropdown-content[data-id=download] div.select-range-type');
  const wrapper = document.querySelector('.content-item-wrapper[data-active="true"]');
  let defaultPrintPage;
  if (wrapper) defaultPrintPage = Number(wrapper.getAttribute('data-currpage')) + 1;
  let html;
  if (selectedPages && selectedPages.length === 0) {
    html = '';
  } else if (
    currentePageOnly &&
    selectedPages.length === 1 &&
    defaultPrintPage &&
    selectedPages[0] === defaultPrintPage
  ) {
    html = INKIVE.TranslateHelper.translate('top_submenu.download_modal.download_current_page_only');
  } else if (selectedPages && selectedPages.length === INKIVE.C.BOOK.num_pages) {
    html = INKIVE.TranslateHelper.translate('top_submenu.download_modal.download_all_pages');
  } else {
    html = `${msgPageSelected} : (${checkPagesInterval(selectedPages)})`;
  }
  submenuItem.querySelector('span').innerHTML = `${html}`;
};

export const checkPagesInterval = (numbers) => {
  return [...numbers].sort((a, b) => a - b).reduce((acumulator, currentValue, i) => {
    if (i === 0) {
      acumulator.ranges.push(currentValue);
      acumulator.rangeStart = currentValue;
    } else {
      if (currentValue === acumulator.last + 1) {
        acumulator.ranges[acumulator.ranges.length - 1] = acumulator.rangeStart + '-' + currentValue;
      } else {
        acumulator.ranges.push(currentValue);
        acumulator.rangeStart = currentValue;
      }
    }
    acumulator.last = currentValue;
    return acumulator;
  }, { ranges: [] }).ranges.join(', ');
};

export const selectVideoFormat = (e) => {
  // TODO: Refactor this whole download modal
  if (e && e.currentTarget) {
    const ul = e.currentTarget.parentElement;
    const li = e.currentTarget;
    const { videoFormat } = li.dataset;
    ul.querySelectorAll('li').forEach(element => element.classList.remove('select-active'));
    ul.parentElement.querySelector('.desygner-dropdown-selected span').textContent = li.querySelector('a span').textContent;
    ul.classList.toggle('visible');
    li.classList.add('select-active');
  }
};

export const selectVideoSize = (e) => {
  if (!e || !e.currentTarget) return;

  const { currentTarget: li } = e;
  const { parentElement: ul } = li;
  const { videoSize } = li.dataset;
  const resolution = videoSize === 'original' ? null : videoSizeToResolution[videoSize];
  ul.querySelectorAll('li').forEach(element => element.classList.remove('select-active'));
  ul.parentElement.querySelector('.desygner-dropdown-selected span').textContent = li.querySelector('a span').textContent;
  ul.classList.toggle('visible');
  li.classList.add('select-active');
};

export const toggleDownloadSubOption = function (e) {
  const field = e.currentTarget;
  DownloadStorageManage.saveFieldOnStore(field, 'downloadOptions');
};

export const updateDownloadOptionsStore = (e) => {
  const field = e.currentTarget ? e.currentTarget : e;
  DownloadStorageManage.saveFieldOnStore(field, 'downloadOptions');
};

export const selectDownloadType = function (event) {
  let selected = event && event.currentTarget;
  const modal = document.querySelector('.ui-dropdown-content[data-id=download]');
  const dropdownList = modal.querySelector('.select-print-format');
  let type = selected ? selected.dataset.printFormat : sessionStorage.getItem('lastSelectedTab') || 'pdf-print';
  const AnimationButtonExistsAndItsHidden = document.querySelectorAll('[title="Animation"]').length && (document.querySelector('[title="Animation"]').parentNode.style.display === 'none');
  const showAnimation = INKIVE.C.SHOW_ANIMATION && INKIVE.RestrictionsFacade.isFunctionalityAllowed('function_animation_file');

  function togglePngTransparentOption () {
    const isForcedTransparency = document.querySelector('input[type="checkbox"][name="isForcedTransparency"]');
    const isClicked = window.getComputedStyle(isForcedTransparency.parentElement.querySelector('span'), ':after').content !== 'none';
    const SVGBackgroundIsTransparent = document.querySelector(`#${config.background.color}`).getAttribute('fill')?.toLowerCase() === 'none';
    const currentPageIsSelected = selectedPages.length === 0 || (selectedPages.length === 1 && selectedPages[0] === INKIVE.Tool._current_page_number);
    if (isForcedTransparency && !isClicked && SVGBackgroundIsTransparent && currentPageIsSelected) {
      isForcedTransparency.value = true;
      isForcedTransparency.click();
    }
  }

  togglePngTransparentOption();

  if (sessionStorage.getItem('lastSelectedTab') === 'video' && (!!AnimationButtonExistsAndItsHidden || !showAnimation)) {
    type = 'pdf-print';
  }

  if (!selected) {
    type = DownloadStorageManage.getDownloadFormat();
    selected = modal.querySelector(`li[data-print-format='${type}']`);
  }

  modal.querySelector('.selected-print-format span').textContent = selected.querySelector('a span').textContent;
  DownloadStorageManage.saveFieldOnStore(type, 'lastSelectedTab');
  DownloadStorageManage.saveFieldOnStore(type, 'selectedFormat');
  DownloadStorageManage.setSavedDownloadInputs();

  if (type === 'pdf-print') {
    modal.querySelector('.print-pdf-settings').classList.add('active');
    type = 'pdf-stand';
    quality = 'print';
  } else {
    modal.querySelector('.print-pdf-settings').classList.remove('active');
    quality = 'web';
    bleed.hideCanvasBleed();
    bleed.uncheckPDFPrintOptions();
  }

  modal.querySelectorAll('.ui-tabs-panel').forEach(elements => {
    const toggleDownloadOptions = elements.dataset.local === type;

    elements.setAttribute('aria-hidden', !toggleDownloadOptions);
    elements.setAttribute('aria-expanded', toggleDownloadOptions);
    elements.setAttribute('aria-selected', toggleDownloadOptions);

    elements.classList.toggle('ui-tabs-active', toggleDownloadOptions);
    elements.classList.toggle('ui-state-active', toggleDownloadOptions);

    elements.style.display = elements.dataset.local === type ? 'block' : 'none';
  });

  dropdownList.querySelectorAll(' .desygner-dropdown-select-item').forEach(element => {
    element.classList.remove('select-active');
  });

  modal.querySelectorAll('.download-btn-container').forEach(btnContainer => {
    const toggleDownloadButton = type === btnContainer.dataset.local;
    btnContainer.classList.toggle('active', toggleDownloadButton);
  });

  dropdownList.classList.toggle('visible');
  selected.classList.add('select-active');

  const selectedCheckBoxesMenu = document.querySelector('div.select-range-type');

  downloadDefaultRange();
  selectedCheckBoxesMenu.classList.remove('error');
  disableDownloadIfNoPagesSelected(selectedPages);
  rangeInitialValue();

  const downloadButtons = document.querySelectorAll('a.btn.btn-yellow.action.disabled[data-action]');
  downloadButtons.forEach((downloadButton) => {
    !INKIVE.EditorFacade.isLoading && downloadButton.classList.remove('disabled');
  });
};
